import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'

import { projectContext, loadingContext, unfolder, useTranslate } from '../lib'
import { urlValue } from '../lib'
import '../styles/styles.css'
import '../styles/newProjectModal.scss'
import { customModal } from '../styles/customModal'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

export default function EditSubCampaingModal({ isModalOpen, closeModal }) {
  const [loading, setLoading] = useContext(loadingContext)
 

  const [error, setError] = useState({ name: "" })
  const { t } = useTranslate();
  const subCampaingRef = useRef()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
 
  const edit = async () => {

    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g;
    if (!exp.test(subCampaingRef.current.value)) {
      ok = false;
      setError({ ...error, name: t('errors.nameInvalid') })
    }

    if (ok) {
      const dataSend = {
        name: subCampaingRef.current.value,
        id: isModalOpen?.subcampaing?.sub_campaing_id || 0
      }

      axios({
        method:  'put',  
        url: `${urlValue}/studio/project/camp/sub-campaing`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          closeModal()
          setLoading(false)
          window.location.href = "/";
        })
        .catch(function (error) {
          closeModal()
          setLoading(false)
        })
    }
  }

  return (
    // <Modal isOpen={isModalOpen.editSubCampaing} style={customModal} ariaHideApp={false}>
      <div className="newProject-modal newCampaing-modal">
        <h1>{ t('menu.editSubCampaign')   }</h1>
        <form style={{width: '100%'}} >
          <div className="inputs" id="name">
            <div className="input ">
              <span>{t('common.name')}:</span>
              <input id='editcp-tp' className='input-data' ref={subCampaingRef}  defaultValue={isModalOpen?.subcampaing?.sub_campaing_name}  type="text" />
              {/* <span className="tooltiptext">Only these characters are accepted A-Za-z0-9-,._'¿?<div className='triangulo'></div></span> */}
              <Tooltip   anchorId="editcp-tp" content={t('alerts.charactersNameTooltip')} place="top" />
            </div>
          </div>

          <div className="footer">
            <div className='cont-buttons'>
              {errors.name?.type === 'required'
                ? (
                  <span style={{ color: "red" }}>{t('menu.fieldsRequired')}</span>
                ) : (
                  <span> </span>
                )}
              <span className='errors-msg'  >{error.name}</span>
            </div>
            <div className='cont-buttons' style={{marginTop: 25}}>
              <div className="buttons">
                <button className="cancel btn-bottom btn-bottom-cancel" type="button" onClick={() => closeModal()}>
                  {t('common.cancel')}
                </button>
                <button onClick={()=>edit()} className="create btn-bottom btn-bottom-create" type="button">
                  {t('common.edit')}
                </button>
              </div>

            </div>
          </div>

        </form>
      </div>
    // </Modal>
  )
}
